import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaHtml5, FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';


function SalesnewReport() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [tripDate, setTripDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [saleOrderId, setSaleOrderId] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomerData, setSelectedCustomerData] = useState(null);
    const [fromdate, setfromdate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);

    const [saledata, setSData] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setfromdate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchtrips();
        fetchSalesmans();
        fetchPCategoryTypes();
        fetchvehicle();
        fetchCategoryTypes();
        fetchItems();

    }, [isAuthenticated, companyId, token, logout]);


    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };
    //search
    const filteredData = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setfromdate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };




    const [VehicleOptions, setVehicleOptions] = useState([]); // Correct naming convention
    const [selectedvehicle, setselectedvehicle] = useState(null); // Use null to represent no selection
    const [vehicle, setvehicle] = useState('0'); // Default to '0' if no salesman selected

    // Function to fetch Salesman details from API
    const fetchvehicle = () => {
        fetchData('VehicleApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((vehicle) => ({
                    label: vehicle.vehicleNo,
                    value: vehicle.id,
                }));
                setVehicleOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching salesman data:', error);
            });
    };


    const handleVehicleSelect = (selectedOption) => {
        setselectedvehicle(selectedOption || null); // Ensure selectedOption is not undefined
        const vehicle = selectedOption?.value || '0'; // Fallback to '0' if no selection
        setvehicle(vehicle); // Update salesman state with selected ID
        setDataItem([]); // Reset related data if needed
    };


    const [tripOptions, settripOptions] = useState([]);
    const [selectedtrip, setselectedtrip] = useState(null);
    const [routeid, settripId] = useState('0');

    //FOR GET trip  Details FROM API
    // FOR GET trip Details FROM API
    const fetchtrips = async () => {  // Add 'async' here
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                // Transform the data into the format that react-select expects (label and value)
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                settripOptions(options);
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };


    const handletripSelect = (selectedOption) => {
        setselectedtrip(selectedOption);  // Set the selected option as state
        const routeid = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        settripId(routeid);  // Set executiveId state
        setDataItem([]);  // Reset any related data
    };


    const [selectedPCategory, setSelectedPCategory] = useState(null);
    const [pcategoryOptions, setPCategoryOptions] = useState([]);
    const [pcategory, setPCategoryId] = useState('0');


    // Fetch Product Category Types
    const fetchPCategoryTypes = async () => {
        try {
            const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setPCategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching product category data:', error);
        }
    };

    const handlePCatSelect = (selectedOption) => {
        setSelectedPCategory(selectedOption);  // Set the selected option as state
        const pcategory = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        setPCategoryId(pcategory);  // Set executiveId state
        setDataItem([]);  // Reset any related data
    };


    const [categoryOptions, setcategoryOptions] = useState([]);
    const [selectedCategory, setselectedCategory] = useState(null);
    const [category, setcategoryId] = useState('0');

    // Fetch Category Types
    const fetchCategoryTypes = async () => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setcategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const handlecatorySelect = (selectedOption) => {
        setselectedCategory(selectedOption);  // Set the selected option as state
        const category = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        setcategoryId(category);  // Set executiveId state
        setDataItem([]);  // Reset any related data
    };
    const [itemOptions, setitemOptions] = useState([]);
    const [selecteditem, setselecteditem] = useState(null);
    const [Item, setItemId] = useState('0');

    // Fetch Items
    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleReportAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(Item => ({
                    value: Item.id,
                    label: Item.name
                }));
                setitemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching item data:', error);
        }
    };
    const handleitemSelect = (selectedOption) => {
        setselecteditem(selectedOption);  // Set the selected option as state
        const Item = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        setItemId(Item);  // Set executiveId state
        setDataItem([]);  // Reset any related data
    };


    const [orderdate, setOrderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");
    const [route, setroute] = useState("");
    const [loading, setLoading] = useState(false);

    const [salesmanOptions, setSalesmanOptions] = useState([]); // Correct naming convention
    const [selectedSalesman, setSelectedSalesman] = useState(null); // Use null to represent no selection
    const [salesman, setSalesman] = useState('0'); // Default to '0' if no salesman selected

    // Function to fetch Salesman details from API
    const fetchSalesmans = () => {
        fetchData('executiveApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((Salesman) => ({
                    label: Salesman.firstName,
                    value: Salesman.id,
                }));
                setSalesmanOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching salesman data:', error);
            });
    };


    const handleSalesmanSelect = (selectedOption) => {
        setSelectedSalesman(selectedOption || null); // Ensure selectedOption is not undefined
        const salesmanId = selectedOption?.value || '0'; // Fallback to '0' if no selection
        setSalesman(salesmanId); // Update salesman state with selected ID
        setDataItem([]); // Reset related data if needed
    };


    // // Fetch Table Data
    const fetchTableData = async () => {
        // Clear dropdown fields

        setDataItem([]);
        setLoading(true);

        try {
            const response = await fetchData(
                'SaleReportAPI',
                `/${companyId}/${routeid}/${fromdate}/${toDate}/${salesman}/${pcategory}/${category}/${Item}/${vehicle}`,
                token
            );

            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
                setData(response.response_data);  // Use response data directly
                if (response.response_data.length > 0) {
                    setSaleOrderId(response.response_data[0].id);
                    setOrderdate(response.response_data[0].orderDate);
                    setOrdertakenby(response.response_data[0].orderTakenby);
                    setroute(response.response_data[0].routeName);
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        } finally {
            setLoading(false);
        }
    };



    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Sales Report</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Sales Report</h3>');
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');

        // Column headers
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Route Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sales Executive</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Driver Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Product Category</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Category</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">UOM (Kgs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Quantity (No.Pieces)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bundle</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Pieces</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total Qty (kgs)</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        let previousRouteName = '';
        let previousSalesman = '';
        let previousDriverName = '';
        let previousProductCategory = '';

        // Table rows
        data.forEach((rowData, index) => {
            const showRouteName = rowData.routeName !== previousRouteName;
            const showSalesman = rowData.salesman !== previousSalesman;
            const showDriverName = rowData.DriverName !== previousDriverName;
            const showProductCategory = rowData.productCategory !== previousProductCategory;

            // Update previous values
            previousRouteName = rowData.routeName;
            previousSalesman = rowData.salesman;
            previousDriverName = rowData.DriverName;
            previousProductCategory = rowData.productCategory;

            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center;">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${showRouteName ? (rowData.routeName || '') : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${showSalesman ? (rowData.salesman || '') : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${showDriverName ? (rowData.DriverName || '') : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${showProductCategory ? (rowData.productCategory || '') : ''}</td>`);

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.ordertype || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.itemCode || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.item || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center;">${rowData.kilogram || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center;">${rowData.quantity || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center;">${rowData.Bundle || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center;">${rowData.Pieces || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center;">${rowData.totalquantity || ''}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };


    //excel
    const handleExportExcel = () => {
        const excelData = [];

        // Add header row
        const headerRow = [
            'Sl.No',
            'Route Name',
            'Sales Executive',
            'Driver Name',
            'Product Category',
            'Category',
            'Item Code',
            'Item',
            'UOM (Kgs)',
            'Quantity',
            'Bundle',
            'Pieces',
            'Total Quantity',
        ];
        excelData.push(headerRow);

        // Initialize variables to track previous values
        let previousRouteName = '';
        let previousSalesman = '';
        let previousDriverName = '';
        let previousProductCategory = '';

        // Add data rows
        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                // Only show Route Name if it differs from the previous row
                rowData.routeName !== previousRouteName ? rowData.routeName : '',
                rowData.salesman !== previousSalesman ? rowData.salesman : '',
                rowData.DriverName !== previousDriverName ? rowData.DriverName : '',
                rowData.productCategory !== previousProductCategory ? rowData.productCategory : '',
                rowData.ordertype || '',
                rowData.itemCode || '',
                rowData.item || '',
                rowData.kilogram || '',
                rowData.quantity || '',
                rowData.Bundle || '',
                rowData.Pieces || '',
                rowData.totalquantity || '',
            ];

            // Update previous values
            previousRouteName = rowData.routeName;
            previousSalesman = rowData.salesman;
            previousDriverName = rowData.DriverName;
            previousProductCategory = rowData.productCategory;

            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sale Report');

        // Save workbook to a file
        XLSX.writeFile(wb, 'Sale Report.xlsx');
    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(150); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'SL No',
        'Customer Name',
        'GST No ',
        'Bill No.',
        'Bill Amount',
        'CGST',
        'SGST',
        'IGST',
        'Total'

    ]);
    // Process and paginate the data
    const processedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const calculateGrandTotal = () => {
        let grandTotal = {
            kilogram: 0,
            quantity: 0,
            Bundle: 0,
            Pieces: 0,
            totalquantity: 0
        };

        dataItem.forEach(item => {
            if (item.productCategory && item.productCategory.includes('Total')) {
                grandTotal.kilogram += parseFloat(item.kilogram) || 0;
                grandTotal.quantity += parseFloat(item.quantity) || 0;
                grandTotal.Bundle += parseFloat(item.Bundle) || 0;
                grandTotal.Pieces += parseFloat(item.Pieces) || 0;
                grandTotal.totalquantity += parseFloat(item.totalquantity) || 0;
            }
        });

        return grandTotal;
    };
    const grandTotal = calculateGrandTotal();

    let previousSalesman = null;
    let previousProductCategory = null;
    let previousrouteName = null;
    let previousdriverName = null;

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className="flex justify-start mb-4" style={{ marginTop: '-8px' }}>
                <h6 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', marginTop: '10px', width: '20%' }}>SALE REPORT(DSR)</h6>
                <div className="w-1/8 mr-2">
                    <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="fromDate">
                        FROM DATE
                    </label>
                    <input
                        className="shadow appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromdate} onChange={handleFromDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <div className="w-1/8 mr-2">
                    <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                        TO DATE
                    </label>
                    <input
                        className="shadow appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                 <Button onClick={fetchTableData} style={{
                    backgroundColor: '#C9E9D2',
                    color: 'black',
                    height: '36px',
                    marginTop: '20px',
                    marginLeft: '5px'
                }}
                    disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Refresh"}
                </Button>
                <Button
                    onClick={handleExportExcel}
                    className="linkcolor"
                    style={{
                        backgroundColor: '#F8E8EE',
                        color: 'black',
                        height: '36px',
                        marginTop: '20px',
                        marginLeft: '5px'
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Excel"}
                </Button>

                {/* Print Button */}

                <Button
                    onClick={handlePrint}
                    className="linkcolor"
                    style={{
                        backgroundColor: '#E8F3D6',
                        color: 'black',
                        height: '36px',
                        marginTop: '20px',
                        marginLeft: '5px'
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Print"}
                </Button>

               

            </div>
            <div className="w-full">

                <div className="flex justify-start mb-4" style={{ marginTop: '-1.5%' }}>

                    <div className="w-1/3 mr-2">
                        <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="trip">
                            SELECT TRIP
                        </label>
                        <Select
                            id="tripSelect"
                            value={selectedtrip}
                            onChange={handletripSelect}
                            options={tripOptions}
                            placeholder="Select Trip"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>

                    <div className="w-1/3 mr-2">
                        <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                            PRODUCT CATEGORY
                        </label>
                        <Select
                            id=" ProductCategory"
                            value={selectedPCategory}
                            onChange={handlePCatSelect}
                            options={pcategoryOptions}
                            placeholder=" PCategory"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>
                    <div className="w-1/3 mr-2">
                        <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                            CATEGORY
                        </label>
                        <Select
                            id="Category"
                            value={selectedCategory}
                            onChange={handlecatorySelect}
                            options={categoryOptions}
                            placeholder="Category"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>
                    <div className="w-1/3 mr-2">
                        <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                            ITEM
                        </label>
                        <Select
                            id="item"
                            value={selecteditem}
                            onChange={handleitemSelect}
                            options={itemOptions}
                            placeholder="item"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                            SALESMAN
                        </label>
                        <Select
                            id="salesmanSelect"
                            value={selectedSalesman}
                            onChange={handleSalesmanSelect}
                            options={salesmanOptions}
                            placeholder="SalesMan"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                            VEHICLE NO.
                        </label>
                        <Select
                            id="vehicleSelect"
                            value={selectedvehicle}
                            onChange={handleVehicleSelect}
                            options={VehicleOptions}
                            placeholder="Vehicle"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>
                    <div className="flex justify-center" style={{ marginTop: '30px' }}>

                    </div>
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '480px', overflowY: 'auto', marginTop: '-1%' }}>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{
                            backgroundColor: '#08396B', Width: '2500px', position: 'sticky', // Makes the header sticky
                            top: 0,             // Locks it to the top
                            zIndex: 1,
                        }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Route Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Sales Executive</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Driver Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Product Category</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Category</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Code</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Item</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center', width: '85px' }}>UOM (Kgs)</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Quantity(No.Pieces)</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Bundle</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Pieces</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Qty(kgs)</TableCell>

                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: '##E4E0E1' }}>
                            {/* Filtered data excluding the Grand Total */}
                            {processedData.filter(item => item.productCategory !== 'GRAND TOTAL').map((item, index) => {
                                // Check if the row is a category total, product category total
                                const isCategoryTotal = item.ordertype && item.ordertype.includes('Total');
                                const isProductCategoryTotal = item.productCategory && item.productCategory.includes('Total');

                                // Check if the current salesman and productCategory are different from the previous ones
                                const showSalesman = item.salesman !== previousSalesman;
                                const showProductCategory = item.productCategory !== previousProductCategory;
                                const showRouteName = item.routeName !== previousrouteName;
                                const showDriverName = item.DriverName !== previousdriverName;


                                // Update the previous values
                                previousSalesman = item.salesman;
                                previousProductCategory = item.productCategory;
                                previousrouteName = item.routeName;
                                previousdriverName = item.DriverName;
                                return (
                                    <TableRow
                                        key={item.id}
                                        className={isCategoryTotal || isProductCategoryTotal ? 'highlighted-row' : ''}
                                        sx={{
                                            padding: '3px',
                                            height: '32px',
                                            backgroundColor: isCategoryTotal || isProductCategoryTotal ? '#d1e3f2' : 'transparent', // Custom highlight color
                                        }}
                                    >
                                        <TableCell
                                            sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}
                                        >
                                            {showRouteName ? item.routeName : ""}
                                        </TableCell>
                                        <TableCell
                                            sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}
                                        >
                                            {showSalesman ? item.salesman : ""}
                                        </TableCell>
                                        <TableCell
                                            sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}
                                        >
                                            {showDriverName ? item.DriverName : ""}
                                        </TableCell>
                                        <TableCell
                                            sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}
                                        >
                                            {showProductCategory ? item.productCategory : ""}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>
                                            {item.ordertype}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>
                                            {item.itemCode}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'darkblue', padding: '3px', textAlign: 'left' }}>
                                            {item.item}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                            {item.kilogram}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                            {item.quantity}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                            {item.Bundle}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                            {item.Pieces}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                            {item.totalquantity}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}

                            {/* Grand Total Row */}
                            <TableRow
                                key="grand-total"
                                className='highlighted-row'
                                sx={{
                                    padding: '3px',
                                    height: '32px',
                                    backgroundColor: '#E7CCCC', // Custom highlight color for grand total
                                }}
                            >
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>

                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>

                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>

                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>
                                    {/* Display 'Grand Total' or leave empty */}
                                    Grand Total
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>

                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>

                                </TableCell>

                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>

                                </TableCell>
                                {/* Other cells */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                    {grandTotal.kilogram}
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                    {grandTotal.quantity}
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                    {grandTotal.Bundle}
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                    {grandTotal.Pieces}
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                    {grandTotal.totalquantity}
                                </TableCell>
                            </TableRow>

                        </TableBody>
                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    // rowsPerPageOptions={[15, 25, 50, 100]}
                                    rowsPerPageOptions={[15, 25, 50, 100, 150, 250, 350, 500]}
                                    count={filteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>


                </TableContainer>

            </div>

        </div>

    );
}

export default SalesnewReport;